import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'ui/Button';
import StyledTextField from 'ui/StyledComponents/StyledTextField';

// Tracking details for one parcel — every field is optional (untracked and
// hand-delivered parcels are common). Used blank by Ship and prefilled by
// Edit (SELL21).
const ShipmentForm = ({ shipment, submitLabel, onSubmit, onCancel }) => {
  const [values, setValues] = useState({
    tracking_number: shipment?.tracking_number || '',
    tracking_url: shipment?.tracking_url || '',
    notes: shipment?.notes || '',
  });

  const handleChange = (field) => (event) => {
    setValues({ ...values, [field]: event.target.value });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, margin: '8px 0' }}>
      <StyledTextField
        label="Tracking number (optional)"
        size="small"
        value={values.tracking_number}
        onChange={handleChange('tracking_number')}
      />
      <StyledTextField
        label="Tracking URL (optional)"
        size="small"
        value={values.tracking_url}
        onChange={handleChange('tracking_url')}
      />
      <StyledTextField
        label="Notes (only visible to organizers)"
        size="small"
        multiline
        minRows={2}
        value={values.notes}
        onChange={handleChange('notes')}
      />
      <div style={{ display: 'flex', gap: 8 }}>
        <Button fullwidth highlighted onClick={() => onSubmit(values)}>
          {submitLabel}
        </Button>
        <Button fullwidth onClick={onCancel}>Cancel</Button>
      </div>
    </div>
  );
};

ShipmentForm.propTypes = {
  shipment: PropTypes.object,
  submitLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

export default ShipmentForm;
